import React from 'react';
import { Camera, Film, Gem } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';

const IntroSection = () => {
  const { t } = useTranslation();
  
  return (
    <section className="section-spacing-large bg-cream">
      <div className="container-narrow text-center">
        <div className="gold-accent mx-auto" />
        <h2 className="section-title mb-6">
          {t('about.headline')}
        </h2>
        <p className="subtitle max-w-3xl mx-auto mb-12">
          {t('about.body')}
        </p>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-8 mt-16">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gold/10 rounded-full mb-4">
              <Camera className="text-gold" size={28} />
            </div>
            <h3 className="text-xl font-display font-bold mb-2">{t('about.col1.title')}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              {t('about.col1.body')}
            </p>
          </div>

          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gold/10 rounded-full mb-4">
              <Film className="text-gold" size={28} />
            </div>
            <h3 className="text-xl font-display font-bold mb-2">{t('about.col2.title')}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              {t('about.col2.body')}
            </p>
          </div>

          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gold/10 rounded-full mb-4">
              <Gem className="text-gold" size={28} />
            </div>
            <h3 className="text-xl font-display font-bold mb-2">{t('about.col3.title')}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              {t('about.col3.body')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
